/**
 * The ⓘ on the iPad's "Your tasks" (Tasks Both Ways slice 7, 10/28) — plain
 * words, 7th grade, with real screenshots of the iPad sheet
 * (client/public/help/field-tasks/*.png) marked with numbered pins.
 * Positions are % of the picture.
 */
import type { InfoTopic } from "@/components/info-button";

export const FIELD_TASKS_HELP: Record<"sheet", InfoTopic> = {
    sheet: {
        title: "Your tasks",
        lines: [
            "These are things the office asked you to do. Each card says who it is from.",
            "Tap the big button to open the job. Then answer with one tap.",
            "Done tells the office it's done. Waiting on… says who has the ball. Can't do sends it back with why.",
            "Nothing pings anyone's phone.",
        ],
        shots: [
            {
                src: "/help/field-tasks/sheet.png",
                alt: "The Your tasks cards on the iPad",
                marks: [
                    { x: 14, y: 23, label: "Who asked, and when", side: "right" },
                    { x: 50, y: 32, label: "Tap to open the job", side: "below" },
                    { x: 19, y: 44, label: "Done: they see a green check", side: "below" },
                    { x: 50, y: 44, label: "Waiting on…: who has the ball", side: "below" },
                    { x: 81, y: 44, label: "Can't do: send it back with why", side: "below" },
                ],
            },
            {
                src: "/help/field-tasks/cant-do.png",
                alt: "The Can't do. Why? choices on the iPad",
                marks: [
                    { x: 25, y: 40, label: "Tap one reason. That's it.", side: "below" },
                    { x: 50, y: 74, label: "None of them? Say it yourself", side: "above" },
                ],
            },
        ],
    },
};
